import React from "react";
import * as PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { PaymentsEditor } from "../../components/profileEditors/PaymentsEditor";

export function PaymentsTab({ provider, setProvider }) {
    return (
        <Box sx={{ p: '5px', pb: '25px' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
                Payments
            </Typography>
            <PaymentsEditor provider={provider} setProvider={setProvider} />
        </Box>
    );
}

PaymentsTab.propTypes = {
    provider: PropTypes.shape({
        id: PropTypes.string.isRequired,
        stripeAccepted: PropTypes.bool,
        cashAccepted: PropTypes.bool,
        stripeId: PropTypes.string,
    }).isRequired,
    setProvider: PropTypes.func.isRequired,
};

